/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-shadow */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { Row, Button, UncontrolledDropdown, DropdownToggle, DropdownItem, DropdownMenu, Collapse } from "reactstrap";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import { getLolRequestsWithFilter, getLolRequestsWithOrder, getLolRequestsSearch } from "../../../redux/request/actions";
import LolRequestsApplicationMenu from "../../../components/lolRequests/LolRequestsApplicationMenu";
import RequestList from "../../../components/requests/RequestList";
import ScrollButton from "../../../components/gotoTopScrollButton/ScrollButton";

const LolRequests = ({
  match,
  intl: { messages },
  requestApp: {
    filterLolRequests,
    allRequestItems,
    requestItems,
    lolRequestsItems,
    loading,
    searchKeywordLolRequests,
    orderColumnLolRequests,
    orderColumns,
    allLoaded
  },
  getLolRequestsWithFilter,
  getLolRequestsWithOrder,
  getLolRequestsSearch,
  getRequestListDelta
}) => {
  const getRequests = () => {
    if (lolRequestsItems) {
      if (filterLolRequests) {
        getLolRequestsWithFilter(filterLolRequests.column, filterLolRequests.value);
      }
      if (orderColumnLolRequests) {
        getLolRequestsWithOrder(`${orderColumnLolRequests.column}`, `${orderColumnLolRequests.direction}`);
      }
    }
  };

  const changeOrderBy = (column, direction = "asc") => getLolRequestsWithOrder(column, direction);

  const handleKeyPress = e => {
    getLolRequestsSearch(e.target.value);
  };

  useEffect(() => {
    getRequests();
  }, []);

  const fetchMore = () => {
    getRequestListDelta(true);
    if (filterLolRequests) {
      getLolRequestsWithFilter(filterLolRequests.column, filterLolRequests.value);
    }
  };

  const loadMoreButton = () => {
    const oldestItemDate = new Date(
      requestItems?.sort((aItem, bItem) => aItem.updated_at - bItem.updated_at)?.[0]?.updated_at * 1000
    ).toLocaleDateString();
    if (allLoaded) {
      return (
        <Button color="light">
          <IntlMessages id="seen_all" /> <IntlMessages id="click_to_load_until" />
          {oldestItemDate}
        </Button>
      );
    }
    return (
      <Button color="primary" onClick={fetchMore}>
        <IntlMessages id="click_to_load" /> <IntlMessages id="click_to_load_until" /> {oldestItemDate}
      </Button>
    );
  };

  return (
    <Row className="app-row survey-app">
      <Colxx xxs="12">
        <div style={{ backgroundColor: "#f8f8f8", position: "sticky", top: "3%", zIndex: "1" }}>
          <div className="mb-2">
            <h1>
              <IntlMessages id="menu.lolRequests" />
            </h1>
          </div>
          <div className="mb-2">
            <Button color="empty" className="d-inline-block d-md-none">
              <IntlMessages id="request.display-options" /> <i className="simple-icon-arrow-down align-middle" />
            </Button>
            <Collapse id="displayOptions" className="d-md-block" isOpen>
              <div className="d-block mb-2 d-md-inline-block">
                {
                  <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      <IntlMessages id="request.orderby" />
                      {orderColumnLolRequests ? <IntlMessages id={`request.${orderColumnLolRequests.label}`} /> : ""}
                    </DropdownToggle>
                    <DropdownMenu>
                      {orderColumns &&
                        Object.values(orderColumns).length &&
                        orderColumns.map(o => {
                          return (
                            <DropdownItem key={o.column} onClick={() => changeOrderBy(o.column, o.direction)}>
                              <IntlMessages id={`request.${o.label}`} />
                            </DropdownItem>
                          );
                        })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                }
                <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                  <input
                    type="text"
                    name="keyword"
                    id="search"
                    placeholder={messages["menu.search"]}
                    defaultValue={searchKeywordLolRequests}
                    onChange={e => handleKeyPress(e)}
                  />
                </div>
              </div>
            </Collapse>
          </div>
          <Separator className="mb-5" />
        </div>
        <Row>
          <RequestList requests={lolRequestsItems} loading={loading} match={match} />
        </Row>
        <ScrollButton className="app-row" />
        <div className="d-flex flex-column">{loadMoreButton()}</div>
      </Colxx>
      <LolRequestsApplicationMenu />
    </Row>
  );
};

LolRequests.propTypes = {
  requestApp: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  getLolRequestsWithFilter: PropTypes.func.isRequired,
  getLolRequestsWithOrder: PropTypes.func.isRequired,
  getLolRequestsSearch: PropTypes.func.isRequired,
  // eslint-disable-next-line react/require-default-props
  loading: PropTypes.bool
};

const mapStateToProps = ({ requestApp, settings }) => {
  const { locale } = settings;
  return { requestApp, locale };
};
export default injectIntl(
  connect(
    mapStateToProps,
    { getLolRequestsWithFilter, getLolRequestsWithOrder, getLolRequestsSearch }
  )(LolRequests)
);
